import { Link } from '@remix-run/react';

import { Image } from '~/components/Image';
import Typography from '~/components/Typography';
import useAuthors from '~/hooks/useLoaders/useAuthors';
import type { Author } from '~/interfaces/author';

import Section from './Section';
import SectionLoader from './SectionLoader';

interface Props {
  textColor: any;
  fontFamily: string;
  isNewWebBuilder?: boolean;
}

const AuthorsWidgetSection = ({ textColor, fontFamily, isNewWebBuilder = false }: Props) => {
  const { authors } = useAuthors();

  return (
    <Section
      text="Authors"
      viewMoreLink="/authors"
      textColor={textColor}
      fontFamily={fontFamily}
      isNewWebBuilder={isNewWebBuilder}
    >
      {authors ? (
        <div className="space-y-2">
          {authors?.map((author: Author) => {
            return (
              <div key={author.id} className="relative">
                <Link to={`/authors/${author.id}`} className="relative flex items-center space-x-2" prefetch="intent">
                  <div className="h-7 w-7 overflow-hidden rounded-full">
                    <Image
                      src={author.profile_picture.url}
                      alt={author.name}
                      maxWidth={800}
                      loading="lazy"
                      aspectRatio="social"
                    />
                  </div>

                  <Typography
                    as="p"
                    size="sm"
                    color={textColor}
                    fontFamily={fontFamily}
                    fontFamilyv2={isNewWebBuilder ? fontFamily : undefined}
                  >
                    {author.name}
                  </Typography>
                </Link>
              </div>
            );
          })}
        </div>
      ) : (
        <SectionLoader />
      )}
    </Section>
  );
};

export default AuthorsWidgetSection;
